export const REDIRECT_TO = "common/router/redirect";

export const redirectTo = (url: string) => ({
  type: REDIRECT_TO,
  payload: url
});



// WEBPACK FOOTER //
// ./client/modules/common/actions.ts